export const useFooter = () => {
  return {
    name: 'Victor Neil',
    description: 'Desenvolvedor Full Stack apaixonado por criar soluções inovadoras e experiências digitais incríveis.',
    copyright: '2024 Victor Neil. Todos os direitos reservados.',
    githubUrl: 'https://github.com/Neil-Lima',
    linkedinUrl: 'https://www.linkedin.com/in/neil-lima-706606248 ',
  };
};
